import id from '@/helpers/id'

export default [
  {
    label: 'Secciones',
    options: {
      handle: '.drag-handler',
      sort: false,
      group: { name: 'section', pull: 'clone', put: false },
      animation: 150,
      chosenClass: 'section-option-chosen',
      ghostClass: 'section-option-ghost',
      dragClass: 'section-option-drag'
    },
    onClone () {
      return {
        $id: id(),
        $collapsed: false,
        $group: 'section',
        $valid: false,
        $children: [],
        name: '',
        description: '',
        helper: ''
      }
    },
    items:
      [
        {
          label: 'Sección',
          group: 'section',
          children: []
        }
      ]
  },
  {
    label: 'Subsecciones',
    options: {
      handle: '.drag-handler',
      sort: false,
      group: {name: 'subsection', pull: 'clone', put: false},
      animation: 150,
      chosenClass: 'section-option-chosen',
      ghostClass: 'section-option-ghost',
      dragClass: 'section-option-drag'
    },
    onClone () {
      return {
        $id: id(),
        $collapsed: false,
        $group: 'subsection',
        $valid: false,
        $children: [],
        name: '',
        description: '',
        helper: ''
      }
    },
    items:
      [
        {
          label: 'Subsección',
          group: 'subsection',
          children: []
        }
      ]
  },
  {
    label: 'Preguntas',
    options: {
      handle: '.drag-handler',
      sort: false,
      group: {name: 'question', pull: 'clone', put: false},
      animation: 150,
      chosenClass: 'question-option-chosen',
      ghostClass: 'question-option-ghost',
      dragClass: 'question-option-drag'
    },
    onClone (original) {
      let answers = []
      let result = null
      if (original.type === 'true_or_false') {
        answers = [
          {$id: id(), name: 'Verdadero', $branchPoints: [], $pointsPerBranch: false, $points: 0, $evidenceRequired: false},
          {$id: id(), name: 'Falso', $branchPoints: [], $pointsPerBranch: false, $points: 0, $evidenceRequired: false}
        ]
      } else if (original.type === 'range') {
        answers = [
          {$id: id(), name: 'Puntos', $branchPoints: [], $pointsPerBranch: false, $points: 0}
        ]
      }
      if (original.type === 'multiple') {
        result = []
      }
      return {
        $id: id(),
        $group: 'question',
        $valid: false,
        $answers: answers,
        $result: result,
        $points: 0,
        $baseScore: null,
        name: '',
        type: original.type,
        evidenceRequired: false,
        helper: '',
        description: ''
      }
    },
    items:
      [
        {
          label: 'Opción Multiple',
          group: 'question',
          type: 'multiple'
        },
        {
          label: 'Opción Única',
          group: 'question',
          type: 'unique'
        },
        {
          label: 'Si / No',
          group: 'question',
          type: 'true_or_false'
        },
        {
          label: 'Rango de Opciones',
          group: 'question',
          type: 'range_options'
        },
        {
          label: 'Rango Numérico',
          group: 'question',
          type: 'range'
        }
      ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/designer/api/menu-items.js